import { render, staticRenderFns } from "./OrderCreateOrEdit.vue?vue&type=template&id=f09d022a&"
import script from "./OrderCreateOrEdit.vue?vue&type=script&lang=js&"
export * from "./OrderCreateOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./OrderCreateOrEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports